<template>
  <div
    class="fill-height"
    :style="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? `padding-bottom: 345px; padding-top: 110px;` : `padding-bottom: 610px; padding-top: 64px;`"
    >
    <v-layout wrap>
      <v-flex>
        <section>
          <!-- <v-container>
            <v-row>
              <v-col
                cols="12">
                <v-card
                  flat
                  class="background-default">
                  <v-card-title
                    class="text-h4 white--text justify-center mb-2 pt-6"
                    style="font-weight: 500;">
                    VISI dan MISI
                  </v-card-title>

                  <v-card-subtitle
                    class="body-1 white--text text-center mb-4"
                    style="opacity: 50%; font-weight: 500;">
                    Mengenal VISI dan MISI Kabupaten Klaten.
                  </v-card-subtitle>

                </v-card>
              </v-col>
            </v-row>

          </v-container> -->
          <v-container>
            <v-row>
              <v-col
                cols="12" class="py-0">
                <div class="font-weight-medium mb-4 mt-1" :style="`color: ${set_color}`" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'text-h5' : 'body-1'">
                  Dasar Hukum
                </div>
                <v-card
                  flat>
                  <v-card-text
                    class="body-1 black--text mb-4">
                    <div class="font-weight-medium" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'text-h5' : 'body-1'">
                      <span>Isi Dasar Hukum</span>
                    </div>

                    <div
                      class="mb-6 mt-4">
                      <div class="font-weight-medium" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'title' : 'body-2'">
                        <ol>
                          <li>Peraturan Presiden Nomor 33 Tahun 2012 tentang Jaringan Dokumentasi dan Informasi Hukum Nasional</li>
                          <li>Peraturan Menteri Hukum dan Hak Asasi Manusia Nomor 2 Tahun 2013 tentang Standardisasi Pengelolaan Teknis Dokumentasi dan Informasi Hukum</li>
                          <li>Peraturan Menteri Dalam Negeri Nomor 2 Tahun 2014 tentang Pengelolaan Jaringan Dokumentasi dan Informasi Hukum Kementrian Dalam Negeri dan Pemerintah Daerah</li>
                          <li>Peraturan Gubernur Jawa Tengah Nomor 24 Tahun 2013 tentang Jaringan Dokumentasi dan Informasi Hukum Propinsi Jawa Tengah</li>
                          <li>Peraturan Bupati Klaten Nomor 52 Tahun 2021 tentang Kedudukan Susunan Organisasi Tugas dan Fungsi serta Tata Kerja Sekretariat Dewan Perwakilan Rakyat Daerah Kabupaten Klaten</li>
                          <li>Peraturan Bupati Kabupaten Klaten Nomor 1 Tahun 2020 Jaringan Dokumentasi dan Informasi Hukum Kabupaten Klaten</li>
                        </ol>
                      </div>
                    </div>

                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    data () {
      return {
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        },
        // SEO
        content: {
          url: '/dasar-hukum',
          title: 'Dasar Hukum',
          description: 'Dasar Hukum JDIH Sekretariat Dewan Kabupaten Klaten',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    components: {

    },
    watch: {

    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {

    },
    methods: {

    }
  }
</script>
